import { render, staticRenderFns } from "./invoice-manage-detail.vue?vue&type=template&id=bb823286&scoped=true&"
import script from "./invoice-manage-detail.vue?vue&type=script&lang=js&"
export * from "./invoice-manage-detail.vue?vue&type=script&lang=js&"
import style0 from "./invoice-manage-detail.vue?vue&type=style&index=0&id=bb823286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb823286",
  null
  
)

export default component.exports